<template>
  <div class="calendar-grid">
    <!-- Cabeçalho: coluna vazia + dias da semana -->
    <div class="calendar-header label-cell"></div>
    <div v-for="day in dayLabels" :key="day" class="calendar-header">
      {{ day }}
    </div>

    <!-- Linhas: uma por semana, incluindo célula da semana e dias -->
    <div
      v-for="(semana, weekIndex) in semanas"
      :key="'linha-' + weekIndex"
      style="display: contents"
    >
      <!-- Coluna da semana -->
      <div class="week-label">
        <strong>Semana {{ weekIndex + 1 }}</strong>
      </div>

      <!-- Colunas dos dias -->
      <div
        v-for="dayKey in dayKeys"
        :key="'celula-' + weekIndex + '-' + dayKey"
        class="grid-cell"
      >
        <div
          v-for="(plantao, index) in semana[dayKey]"
          :key="index"
          class="plantao-box"
          :style="{ borderLeft: '4px solid ' + corBordaPlantao(plantao.tipo) }"
          @click="$emit('editar-plantao', { semanaIndex: weekIndex, dayKey, plantaoIndex: index })"
        >
          <div class="caixa-topo">
            <div class="tipo">🩺 {{ plantao.tipo }}</div>
            <div class="inicio">⏰ {{ plantao.inicio }}</div>
          </div>
          <div class="caixa-baixo">
            <div class="medico">👨‍⚕️ {{ plantao.medico }}</div>
            <div class="duracao">⏳ {{ plantao.duracao }}</div>
          </div>
        </div>
        <b-button
          variant="link"
          size="sm"
          class="p-0 mt-1"
          @click="$emit('add-plantao', { semanaIndex: weekIndex, dayKey })"
        >
          ➕ Adicionar
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    semanas: Array
  },
  data() {
    return {
      dayKeys: ['seg', 'ter', 'qua', 'qui', 'sex', 'sab', 'dom'],
      dayLabels: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom']
    }
  },
  methods: {
    corBordaPlantao(tipo) {
      switch ((tipo || '').toLowerCase()) {
        case 'normal': return '#007bff'
        case 'sobreaviso': return '#6c757d'
        case 'extra': return '#fd7e14'
        default: return '#6f42c1'
      }
    }
  }
}
</script>

<style scoped>
.calendar-grid {
  display: grid;
  grid-template-columns: 100px repeat(7, 1fr);
  gap: 0.25rem;
  align-items: start;
  grid-auto-flow: row;
  grid-auto-rows: auto;
}
.calendar-header {
  background-color: #e7f0f9;
  border: 1px solid #dee2e6;
  padding: 0.3rem;
  font-weight: bold;
  text-align: center;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.label-cell {
  background-color: transparent;
  border: none;
}
.week-label {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 8px;
  padding-left: 10px;
  font-weight: bold;
  background-color: #eef3f8;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  /*min-height: 100px;*/

  height: 100%;

}
.grid-cell {
  border: 1px solid #dee2e6;
  padding: 4px;
  background-color: #ffffff;
  border-radius: 6px;
  min-height: 100px;
  display: flex;
  flex-direction: column;
}
.plantao-box {
  background-color: #f8f9fa;
  padding: 4px 6px;
  margin-bottom: 4px;
  font-size: 0.75rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  cursor: pointer;
}
.caixa-topo,
.caixa-baixo {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tipo,
.medico {
  font-weight: bold;
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.inicio,
.duracao {
  font-size: 0.7rem;
  text-align: right;
  color: #555;
}
</style>